import { NOTIFICATION_PATH } from './constants';

export const getNotificationUrl = (metadata = {}) => {
  const { objectId, path } = metadata;
  if (!objectId || !path) return null;

  const {
    SERVICE_REQUESTS,
    SERVICE_REQUEST,
    SERVICE_REQUEST_UPDATE,
    SERVICE_REQUEST_PHOTO,
    SERVICE_REQUEST_FEEDBACK,
    DELIVERY,
    VISITOR,
    VISITOR_LOG,
    BROKER,
    BROKER_LOG,
    AMENITY_RESERVATIONS,
  } = NOTIFICATION_PATH;

  const baseUrl = `/redirect?type=notification&url=`;

  switch (path) {
    case SERVICE_REQUESTS:
      return `${baseUrl}service-requests`;
    case SERVICE_REQUEST:
    case SERVICE_REQUEST_UPDATE:
    case SERVICE_REQUEST_PHOTO:
    case SERVICE_REQUEST_FEEDBACK:
      return `${baseUrl}service-requests/${objectId}`;
    case DELIVERY:
      return `${baseUrl}deliveries/list?id=${objectId}`;
    case VISITOR:
    case VISITOR_LOG:
    case BROKER:
    case BROKER_LOG:
      return `${baseUrl}visitors/profile/${objectId}`;
    case AMENITY_RESERVATIONS:
      return `${baseUrl}amenity/reservations/${objectId}`;
    default:
      return null;
  }
};
